import { createFileRoute } from '@tanstack/react-router';

import Banner from 'src/components/home/Banner';

export const Route = createFileRoute('/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <div className="relative mx-auto flex h-screen w-full flex-col items-center justify-center bg-[#fafafb]">
        <Banner />
      </div>
    </>
  );
}
